<template src="./index.html"></template>

<script>
import { getdata } from './data.js';
import CastMember from './CastMember/index.vue';
import FunctionPermission from './FunctionPermission/index.vue';
import { getRoleData, getNotAssociatedUserInfo, getAssociatedUserInfo, updateUsersToRole, saveOrUpdateRole, quanxgldelete } from '../../../../../api/home.js';
import { hex_md5 } from '../../../../../../md5.js';
export default {
	name: 'PermissionManagement',
	components: {
		CastMember,
		FunctionPermission
	},
	data() {
		return {
			//角色名
			roleName: '',
			//树状
			data: [],
			//Tabs 标签页
			activeName: '1',
			//新建角色弹框
			Roletk: false,
			//新建成员弹框
			Memberk: false,
			Membevalue: [],
			Membecsl: [
				{
					key: 1,
					label: '备选项1'
				}
			],
			id: '',
			form: { Name: '' },
			rules: {
				Name: [{ required: true, message: '请输入角色名', trigger: 'blur' }]
			},
			title:"",
		};
	},
	mounted() {},
	created() {
		this.searrchForData();
	},
	methods: {
		handleClick(){},
		//删除
		deletesc(date) {
			this.$showConfirm({
				message: '确认删除?'
			}).then(res => {
				if (res == 'confirm') {
					let params = { id: date.id };
					quanxgldelete(params).then(res => {
						if (res.data.code == '200') {
							this.$message.success('删除成功');
							this.searrchForData();
							this.id = '';
							this.roleName = '';
						} else {
							this.$message.error(res.data.message);
						}
					});
				}
			});
		},
		//新建角色信息
		Roletksx() {
			this.$refs.form.validate(valid => {
				if (valid) {
					let params = { id: '-1', roleName: this.form.Name };
					saveOrUpdateRole(params).then(res => {
						if (res.data.code == '200') {
							this.$message.success('保存成功');
							this.Roletk = false;
							this.searrchForData();
							this.id = '';
						} else {
							this.$message.error(res.data.message);
						}
					});
				} else {
					return false;
				}
			});
		},
		//新建角色弹框
		Roletktk() {
			this.form.Name = '';
			this.Roletk = true;
			this.$nextTick(() => {
				this.$refs['form'].clearValidate();
			});
		},
		//更新角色用户
		StorableUserSettings() {
			let params = { roleId: this.id, userIds: this.Membevalue.join(',') };
			updateUsersToRole(params).then(res => {
				if (res.data.code == '200') {
					this.$message.success('保存成功');
					this.Memberk = false;
				} else {
					this.$message.error(res.data.message);
				}
			});
		},
		//添加/移除成员
		Memberksx(data,roleName) {
			this.title=roleName+"-添加成员"
			let params = { roleId: data.id, criteriaJson: '', page: 1, rows: 99999, sort: '', order: '' };
			let weihq = [];
			let yihq = [];
			this.Membecsl = [];
			this.Membevalue = [];
			getAssociatedUserInfo(params).then(res => {
				if (res.data.code == '200') {
					yihq = res.data.data;
					getNotAssociatedUserInfo(params).then(res => {
						if (res.data.code == '200') {
							weihq = res.data.data;
							this.Membecsl = weihq.concat(yihq).map(v => {
								return { key: v.id, label: v.userName };
							});
							this.Membevalue = yihq.map(v => v.id);
							this.Memberk = true;
						}
					});
				}
			});
		},
		searrchForData() {
			let params = { criteriaJson: '', page: '1', rows: '99999', sort: '', order: '' };
			getRoleData(params).then(res => {
				if (res.data.code == '200') {
					this.data = res.data.data;
				}
			});
		},
		pitchon(v) {
			this.roleName = v.roleName;
			this.id = v.id;
		}
	}
};
</script>

<style scoped lang="less">
@import url('./index.less');
</style>
